var map = {
	"./Agrigento.json": [
		50468,
		468
	],
	"./Alessandria.json": [
		4545,
		4545
	],
	"./Ancona.json": [
		17712,
		7712
	],
	"./Arezzo.json": [
		68951,
		8951
	],
	"./Ascoli Piceno.json": [
		60023,
		23
	],
	"./Asti.json": [
		9107,
		9107
	],
	"./Avellino.json": [
		94538,
		4538
	],
	"./Bari.json": [
		64392,
		4392
	],
	"./Barletta-Andria-Trani.json": [
		12478,
		2478
	],
	"./Belluno.json": [
		29964,
		7583
	],
	"./Benevento.json": [
		35516,
		5516
	],
	"./Bergamo.json": [
		11801,
		1801
	],
	"./Biella.json": [
		19311,
		9311
	],
	"./Bologna.json": [
		18314,
		8314
	],
	"./BolzanoBozen.json": [
		81849,
		1849
	],
	"./Brescia.json": [
		53815,
		3815
	],
	"./Brindisi.json": [
		77464,
		7464
	],
	"./Cagliari.json": [
		55264,
		5264
	],
	"./Caltanissetta.json": [
		8554,
		8554
	],
	"./Campobasso.json": [
		51198,
		1198
	],
	"./Caserta.json": [
		39233,
		9233
	],
	"./Catania.json": [
		87349,
		7349
	],
	"./Catanzaro.json": [
		897,
		897
	],
	"./Chieti.json": [
		68562,
		8562
	],
	"./Como.json": [
		41310,
		1310
	],
	"./Cosenza.json": [
		14497,
		4497
	],
	"./Cremona.json": [
		50277,
		277
	],
	"./Crotone.json": [
		67090,
		7090
	],
	"./Cuneo.json": [
		6346,
		6346
	],
	"./Enna.json": [
		38786,
		8786
	],
	"./Fermo.json": [
		71789,
		1789
	],
	"./Ferrara.json": [
		88001,
		8001
	],
	"./Firenze.json": [
		24967,
		4967
	],
	"./Foggia.json": [
		15587,
		5587
	],
	"./Forl-Cesena.json": [
		56653,
		6653
	],
	"./Frosinone.json": [
		30576,
		8195
	],
	"./Gallura Nord-Est Sardegna.json": [
		35153,
		5153
	],
	"./Genova.json": [
		99046,
		9046
	],
	"./Gorizia.json": [
		40369,
		369
	],
	"./Grosseto.json": [
		54814,
		4814
	],
	"./Imperia.json": [
		87975,
		7975
	],
	"./Isernia.json": [
		84613,
		4613
	],
	"./LAquila.json": [
		98991,
		8991
	],
	"./La Spezia.json": [
		2711,
		2711
	],
	"./Latina.json": [
		23161,
		3161
	],
	"./Lecce.json": [
		68600,
		8600
	],
	"./Lecco.json": [
		92818,
		2818
	],
	"./Livorno.json": [
		16401,
		6401
	],
	"./Lodi.json": [
		31378,
		1378
	],
	"./Lucca.json": [
		18916,
		8916
	],
	"./Macerata.json": [
		75120,
		5120
	],
	"./Mantova.json": [
		88476,
		8476
	],
	"./Massa-Carrara.json": [
		99244,
		9244
	],
	"./Matera.json": [
		35984,
		5984
	],
	"./Medio Campidano.json": [
		83010,
		3010
	],
	"./Messina.json": [
		70134,
		134
	],
	"./Milano.json": [
		76086,
		6086
	],
	"./Modena.json": [
		38802,
		8802
	],
	"./Monza e della Brianza.json": [
		55279,
		5279
	],
	"./Napoli.json": [
		13103,
		3103
	],
	"./Novara.json": [
		82947,
		2947
	],
	"./Nuoro.json": [
		28121,
		8121
	],
	"./Ogliastra.json": [
		28846,
		8846
	],
	"./Oristano.json": [
		38405,
		8405
	],
	"./Padova.json": [
		76439,
		6439
	],
	"./Palermo.json": [
		17154,
		7154
	],
	"./Parma.json": [
		63873,
		3873
	],
	"./Pavia.json": [
		48217,
		8217
	],
	"./Perugia.json": [
		20997,
		997
	],
	"./Pesaro e Urbino.json": [
		68904,
		8904
	],
	"./Pescara.json": [
		96161,
		6161
	],
	"./Piacenza.json": [
		54445,
		4445
	],
	"./Pisa.json": [
		95063,
		5063
	],
	"./Pistoia.json": [
		78183,
		8183
	],
	"./Pordenone.json": [
		16108,
		6108
	],
	"./Potenza.json": [
		45561,
		5561
	],
	"./Prato.json": [
		79160,
		9160
	],
	"./Ragusa.json": [
		66309,
		6309
	],
	"./Ravenna.json": [
		58895,
		8895
	],
	"./Reggio Calabria.json": [
		80952,
		952
	],
	"./Reggio nellEmilia.json": [
		85537,
		5537
	],
	"./Rieti.json": [
		89499,
		9499
	],
	"./Rimini.json": [
		39778,
		9778
	],
	"./Roma.json": [
		2857,
		2857
	],
	"./Rovigo.json": [
		15188,
		5188
	],
	"./Salerno.json": [
		70060,
		60
	],
	"./Sassari.json": [
		88648,
		8648
	],
	"./Savona.json": [
		85614,
		5614
	],
	"./Siena.json": [
		20993,
		3374
	],
	"./Siracusa.json": [
		91865,
		4246
	],
	"./Sondrio.json": [
		31230,
		1230
	],
	"./Sulcis Iglesiente.json": [
		1516,
		1516
	],
	"./Taranto.json": [
		73117,
		3117
	],
	"./Teramo.json": [
		40434,
		434
	],
	"./Terni.json": [
		25058,
		5058
	],
	"./Torino.json": [
		96411,
		6411
	],
	"./Trapani.json": [
		57775,
		7775
	],
	"./Trento.json": [
		6484,
		6484
	],
	"./Treviso.json": [
		46890,
		6890
	],
	"./Trieste.json": [
		52690,
		2690
	],
	"./Udine.json": [
		75533,
		5533
	],
	"./Valle dAostaValle dAoste.json": [
		84080,
		4080
	],
	"./Varese.json": [
		97700,
		7700
	],
	"./Venezia.json": [
		85948,
		5948
	],
	"./Verbano-Cusio-Ossola.json": [
		77933,
		7933
	],
	"./Vercelli.json": [
		40216,
		216
	],
	"./Verona.json": [
		85199,
		5199
	],
	"./Vibo Valentia.json": [
		37004,
		7004
	],
	"./Vicenza.json": [
		95896,
		5896
	],
	"./Viterbo.json": [
		15323,
		5323
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 87905;
module.exports = webpackAsyncContext;